/**
 * Which labels must stay readable while a link is being drawn (card 7e48a746).
 *
 * The label pass drops a label that would overlap one already placed. While
 * drawing a link that silently hid the very item the user was aiming for
 * until they hovered it. The nodes nearest the pointer are the candidates;
 * they get their label even where it overlaps.
 *
 * Pure over the position buffer (x, y, z per node), so it is testable
 * without WebGL.
 */
export const LINK_LABEL_RADIUS_PX = 140;
export const LINK_LABEL_LIMIT = 6;

/**
 * @param {ArrayLike<number>} positions  x,y,z triples
 * @param {number} count                 how many nodes the buffer holds
 * @param {{x:number,y:number}} cursor   the link's free end, world units
 * @param {number} zoom                  screen px per world unit
 * @param {number} exclude               the node the link starts from
 * @returns {number[]} node indices, nearest first
 */
export function linkLabelCandidates(positions, count, cursor, zoom, exclude) {
  const radius = LINK_LABEL_RADIUS_PX / Math.max(zoom, 1e-6);
  const r2 = radius * radius;
  const near = [];
  for (let i = 0; i < count; i += 1) {
    if (i === exclude) continue;
    const dx = positions[i * 3] - cursor.x;
    const dy = positions[i * 3 + 1] - cursor.y;
    const d2 = dx * dx + dy * dy;
    if (d2 <= r2) near.push([d2, i]);
  }
  near.sort((a, b) => a[0] - b[0]);
  return near.slice(0, LINK_LABEL_LIMIT).map(([, i]) => i);
}
